import { lazy } from "react";

const AppCalendar = lazy(() => import("./AppCalendar"));

const calendarRoutes = [
  {
    path: "/calendarOld",
    component: AppCalendar
  }
];

export default calendarRoutes;
